export default "__VITE_ASSET__CjocoDuN__"